// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentV2RulesEligibilityRuleResultModel {
    static getAttributeTypeMap() {
        return EnrollmentV2RulesEligibilityRuleResultModel.attributeTypeMap;
    }
}
EnrollmentV2RulesEligibilityRuleResultModel.discriminator = undefined;
EnrollmentV2RulesEligibilityRuleResultModel.additionalProperties = false;
EnrollmentV2RulesEligibilityRuleResultModel.attributeTypeMap = [
    {
        "name": "rejectReasonCode",
        "baseName": "rejectReasonCode",
        "type": "string"
    },
    {
        "name": "passed",
        "baseName": "passed",
        "type": "boolean"
    },
    {
        "name": "rejectReasonDescription",
        "baseName": "rejectReasonDescription",
        "type": "string"
    },
];
//# sourceMappingURL=enrollmentV2RulesEligibilityRuleResultModel.js.map